export function limitedFilter (currentUserId, currentUser, data) {
  let filtered = {}
  for (const userId in data) {
    if (userId === currentUserId) {
      filtered[userId] = data[userId]
    } else {
      let keyFlag = false
      for (let itemId in data[userId]) {
        if (data[userId][itemId].limitedAccess) {
          if (data[userId][itemId].limitedAccess.limitedUsers && Object.keys(data[userId][itemId].limitedAccess.limitedUsers).includes(currentUserId)) {
            if (!keyFlag) {
              filtered[userId] = {}
              keyFlag = true
            }
            filtered[userId][itemId] = data[userId][itemId]
          } else if (currentUser.groups) {
            if (data[userId][itemId].limitedAccess.limitedGroups && Object.keys(currentUser.groups).filter(x => Object.keys(data[userId][itemId].limitedAccess.limitedGroups).includes(x)).length > 0) {
              if (!keyFlag) {
                filtered[userId] = {}
                keyFlag = true
              }
              filtered[userId][itemId] = data[userId][itemId]
            } else if (data[userId][itemId].limitedAccess.limitedGroup && Object.keys(currentUser.groups).filter(x => Object.keys(data[userId][itemId].limitedAccess.limitedGroup).includes(x)).length > 0) {
              if (!keyFlag) {
                filtered[userId] = {}
                keyFlag = true
              }
              filtered[userId][itemId] = data[userId][itemId]
            }
          }
        } else {
          if (!keyFlag) {
            filtered[userId] = {}
            keyFlag = true
          }
          filtered[userId][itemId] = data[userId][itemId]
        }
      }
    }
  }
  return filtered
}
export function limitedBrowsingFilter (currentUserId, currentUser, data) {
  let filtered = {}
  for (const userId in data) {
    if (userId === currentUserId) {
      filtered[userId] = data[userId]
    } else {
      let keyFlag = false
      for (let itemId in data[userId]) {
        if (!keyFlag) {
          filtered[userId] = {}
          keyFlag = true
        }
        filtered[userId][itemId] = data[userId][itemId]
        if (data[userId][itemId].limitedAccess) {
          if (!(data[userId][itemId].limitedAccess.limitedUsers && Object.keys(data[userId][itemId].limitedAccess.limitedUsers).includes(currentUserId))) {
            filtered[userId][itemId]['isForceBrowed'] = true
          } else if (currentUser.groups) {
            if (!(data[userId][itemId].limitedAccess.limitedGroups && Object.keys(currentUser.groups).filter(x => Object.keys(data[userId][itemId].limitedAccess.limitedGroups).includes(x)).length > 0)) {
              filtered[userId][itemId]['isForceBrowed'] = true
            } else if (!(data[userId][itemId].limitedAccess.limitedGroup && Object.keys(currentUser.groups).filter(x => Object.keys(data[userId][itemId].limitedAccess.limitedGroup).includes(x)).length > 0)) {
              filtered[userId][itemId]['isForceBrowed'] = true
            }
          }
        } else {
          if (!keyFlag) {
            filtered[userId] = {}
            keyFlag = true
          }
          filtered[userId][itemId] = data[userId][itemId]
        }
      }
    }
  }
  return filtered
}



// WEBPACK FOOTER //
// ./src/stores/filters.js